'use strict';

exports.__esModule = true;
exports['default'] = stringify;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _isRegexp = require('is-regexp');

var _isRegexp2 = _interopRequireDefault(_isRegexp);

var _isobject = require('isobject');

var _isobject2 = _interopRequireDefault(_isobject);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

// Chrome on my machine had performance issues
// with a number greater than 20 and when JSX handler disabled
var MAX_DEPTH = 20;

function handlePrimitive(x) {
  var t = typeof x;
  if (x === null || x === undefined || t === 'number' || t === 'boolean' || _isRegexp2['default'](x)) {
    return String(x);
  }
  return null;
}

function handleFunction(x) {
  if (typeof x === 'function') {
    return String(x).replace(/{[\s\S]*}/, '=> ...').replace(/.*\(/, '(');
  }
  return null;
}

function handleString(x) {
  if (typeof x === 'string') {
    return '"' + x + '"';
  }
  return null;
}

function handleDate(x) {
  if (x instanceof Date) {
    return 'Date(\'' + x.toISOString() + '\')';
  }
  return null;
}

function handleArray(x, next, seen) {
  if (Array.isArray(x)) {
    if (x.length === 0) {
      return '[]';
    }
    seen.push(x);
    var result = '[' + x.map(next).join(', ') + ']';
    seen.pop();
    return result;
  }
  return null;
}

function wrapJsxProp(x) {
  return x[0] === '"' ? x : '{' + x + '}';
}

function wrapJsxChildren(x) {
  if (x[0] === '<') {
    return x;
  }
  if (x[0] === '"') {
    return x.slice(1, x.length - 1);
  }
  return '{' + x + '}';
}

function handleJsx(x, next, seen, indent) {
  if (_react2['default'].isValidElement(x)) {
    var _ret = (function () {
      var lastIndent = indent === '' ? '' : indent.replace(/\s\s$/, '');
      var name = typeof x.type === 'string' ? x.type : x.type.displayName || x.type.name || 'Unknown';
      var defaultProps = x.type && typeof x.type.getDefaultProps === 'function' ? x.type.getDefaultProps() : {};
      var keys = Object.keys(x.props).filter(function (key) {
        return defaultProps[key] !== x.props[key];
      });
      var props = '';
      var children = null;
      if (keys.length > 0) {
        seen.push(x);
        var _keys = keys.filter(function (key) {
          return key !== 'children';
        });
        if (_keys.length > 0) {
          var joint = indent === '' ? ' ' : indent;
          props = _keys.map(function (key) {
            var val = x.props[key];
            return val === true ? key : key + '=' + wrapJsxProp(next(val));
          });
          props = '' + joint + props.join(joint) + lastIndent;
        }
        if (keys.indexOf('children') !== -1) {
          if (Array.isArray(x.props.children)) {
            children = x.props.children.map(function (c) {
              return wrapJsxChildren(next(c));
            }).join('' + indent);
          } else {
            children = wrapJsxChildren(next(x.props.children));
          }
        }
        seen.pop();
      }
      var ending = children === null ? '/>' : '>' + indent + children + lastIndent + '</' + name + '>';
      return {
        v: '<' + name + props + ending
      };
    })();

    if (typeof _ret === 'object') return _ret.v;
  }
  return null;
}

function handleObject(x, next, seen, indent) {
  if (_isobject2['default'](x)) {
    var keys = Object.keys(x);
    if (keys.length === 0) {
      return '{}';
    }
    seen.push(x);
    var joint = indent === '' ? ', ' : ',' + indent;
    var lastIndent = indent === '' ? '' : indent.replace(/\s\s$/, '');
    var body = keys.map(function (key) {
      return key + ': ' + next(x[key]);
    }).join(joint);
    var result = '{' + indent + body + lastIndent + '}';
    seen.pop();
    return result;
  }
  return null;
}

function handleUnknown() {
  return '__UnknownType';
}

var handlers = [handlePrimitive, handleFunction, handleString, handleDate, handleArray, handleJsx, handleObject, handleUnknown];

function stringify(_x, opts) {
  var seen = [];
  function s(x) {
    var _ref = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var _ref$indent = _ref.indent;
    var indent = _ref$indent === undefined ? '\n  ' : _ref$indent;
    var _ref$depthLim = _ref.depthLim;
    var depthLim = _ref$depthLim === undefined ? 0 : _ref$depthLim;
    var _ref$depth = _ref.depth;
    var depth = _ref$depth === undefined ? 0 : _ref$depth;

    if (depth > MAX_DEPTH) {
      return '__DepthLimit';
    }
    if (seen.indexOf(x) !== -1) {
      return '__Circular';
    }
    var i = 0;
    var result = undefined;
    var next = function next(__x) {
      return s(__x, { indent: indent + '  ', depthLim: depthLim - 1, depth: depth + 1 });
    };
    do {
      result = handlers[i](x, next, seen, depthLim > 0 ? indent : '');
      i++;
    } while (result === null);
    return result;
  }
  return s(_x, opts);
}

module.exports = exports['default'];